@use "ui/styles/colorsOld";
@use "ui/styles/fontsOld";

@keyframes textFade {
  0% {
    opacity: 1;
  }
  30% {
    opacity: 1;
  }
  65% {
    opacity: 0.2;
  }
}

@keyframes segment-rotation {
  to {
    transform: rotate(360deg);
  }
}

.wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  transition: opacity 0.05s linear;
  transition-delay: 3s;
  margin: 0 auto;
  height: 200px;
  width: 240px;
  color: colorsOld.$stoneDark;

  .content {
    > div {
      padding: 4px;
      margin: 0 auto;
    }
  }

  .text {
    font-weight: fontsOld.$book-weight;
    text-align: center;

    animation: textFade ease-in-out 1.5s infinite;
  }
  :global {
    .segment {
      transform-origin: 9px 9px; // SVG viewbox is 18x18
      & :local {
        animation: segment-rotation linear 1s infinite;
      }
    }
  }
}

.medium .content {
  transform: scale(1.25);
}

.large .content {
  transform: scale(1.5);
}

.row {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.fullScreen {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 9999;
  background: colorsOld.$sapphireLightX5;
}

.fill {
  width: 100%;
  height: 100%;
}

.icon {
  > div {
    padding: 0;
  }

  width: unset;
  height: unset;
}

.above {
  .text {
    order: 0;
  }

  svg {
    order: 1;
  }
}

.below {
  .text {
    order: 1;
  }

  svg {
    order: 0;
  }
}
